import React, { PureComponent } from 'react';

import Button from 'widgets/Button';

export default class FoodProfileFailed extends PureComponent {
  render() {
    return (
      <div className="js-foodProfilePopup__success">
        <div className="js-foodProfilePopup__headerBar">
          <h3>Your Food Profile is set up</h3>
          <Button
            className="js-createFoodProfileClose"
            onClick={this.props.closeHandler}
          />
        </div>
        <img src="/webshop/static/images/components/foodProfile/RHS_artichoke.jpg" alt="" />
        <p>
          You’re all set to shop with even more freedom than before. If you ever need
          to make changes to your Food Profile, head over to your Account Settings
          and toggle on or off the ingredients you need to amend.
    </p>
        <div className="js-foodProfilePopup__actionBar">
          <a href="https://www.foodmaestro.me/">Powered by Foodmaestro</a>
          <Button onClick={this.props.closeHandler}>OK</Button>
        </div>
      </div>
    );
  }
}
